import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import { cn } from "@helpers/general";
import { useTracking } from "@context/Tracking";
import { withALErrorBoundary } from "@helpers/ErrorBoundary/ALErrorBoundary";
import { Link } from "@components/al_components/ALLink";

import Customizable from "@images/custom.png";

function MenuCategory({ category, menuTitle, closeMenu }) {
  const { fontColor: color, title, titleLink, links } = category;
  const menuCategoryRef = useRef(null);
  const { trackMenuClick } = useTracking();
  const [heightElement, updateHeightContainer] = useState(null);

  useEffect(() => {
    if (menuCategoryRef.current) {
      updateHeightContainer(menuCategoryRef.current.offsetHeight);
    }
  }, []);

  const onMenuLinkClick = ({ destinationUrl, subCategoryTitle }) => {
    trackMenuClick({
      destinationUrl,
      menuTitle,
      categoryTitle: title,
      subCategoryTitle: subCategoryTitle || "",
      sourceType: "text",
    });
    closeMenu();
  };

  const isSubItemsEmpty = category?.links[0]?.title === "empty";

  return (
    <div
      className={cn("min-w-[106px]", isSubItemsEmpty && "mb-0", "gap-[80px]")}
      ref={menuCategoryRef}
      style={heightElement ? { height: `${heightElement}px` } : {}}
    >
      {titleLink.trim() === "#" ? (
        <h3
          className="typo-micro font-bold mb-[20px] mt-0 capitalize flex items-center gap-[6px]"
          style={{ color }}
        >
          {title.toLowerCase().includes("personalized") && (
            <img
              className="w-[14px] h-[14px]"
              src={Customizable}
              alt="Customizable"
              loading="lazy"
            />
          )}
          {title}
        </h3>
      ) : (
        <Link
          to={titleLink}
          onClick={() => onMenuLinkClick({ destinationUrl: titleLink })}
          className="text text--bold text--uc block mb-[25px] mt-0 mr-0 menu-link-underline"
          style={{ color }}
        >
          {title}
        </Link>
      )}
      <ul className="flex flex-col gap-5 p-0 m-0">
        {links?.map((link) => {
          if (link.title !== "empty") {
            return (
              <li className="typo-micro list-none" key={link.id}>
                <Link
                  onClick={() =>
                    onMenuLinkClick({
                      destinationUrl: link.link.link,
                      subCategoryTitle: link.title,
                    })
                  }
                  to={link.link.link}
                  className="menu-link-underline inline-block"
                >
                  {link.title}
                </Link>
              </li>
            );
          }
          return null;
        })}
      </ul>
    </div>
  );
}

MenuCategory.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.string.isRequired,
    fontColor: PropTypes.string,
    links: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        link: PropTypes.shape({
          link: PropTypes.string,
        }),
        title: PropTypes.string,
      })
    ),
    title: PropTypes.string.isRequired,
    titleLink: PropTypes.string.isRequired,
  }),
  menuTitle: PropTypes.string,
  closeMenu: PropTypes.func,
};

export default withALErrorBoundary({
  name: "MenuCategory",
  priority: "P2",
})(MenuCategory);
